import React, {ForwardedRef, forwardRef, useMemo} from "react";

interface IDayProps {
  day: Date
  isSelected: boolean,
  isFocused: boolean,
  // eslint-disable-next-line no-unused-vars
  setSeletedDate: (date: Date) => void,
  disabled: boolean,
  available?: boolean,
  ariaLabelledBy?: string
  datepickerId: string
  isInCurrentMonth: boolean
  showDaysInPrevAndNextMonth?: boolean
}

const Day = forwardRef(
  (
    {
      day,
      isSelected,
      setSeletedDate,
      disabled,
      available,
      ariaLabelledBy,
      datepickerId,
      isInCurrentMonth,
      isFocused,
      showDaysInPrevAndNextMonth = false
    }: IDayProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    const label = new Intl.DateTimeFormat("no-NB", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    }).format(day);

    const renderBlank = useMemo(() => {
      return !showDaysInPrevAndNextMonth && !isInCurrentMonth
    }, [showDaysInPrevAndNextMonth, isInCurrentMonth])

    const id = `id-${label.replaceAll(" ", "-").replaceAll(".", "")}-${datepickerId}`

    let className = "datepicker__day"

    if (available) {
      className += " datepicker__day--available"
    }
    if (isSelected) {
      className += " datepicker__day--selected"
    }
    if (isFocused) {
      className += " datepicker__day--focused"
    }
    if (isInCurrentMonth) {
      className += " datepicker__day--current-month"
    }

    return (
      <td key={JSON.stringify(day)}>
        {day && (
          renderBlank ?
            <div />
            :
            <button
              className={className}
              type="button"
              id={id}
              tabIndex={(isSelected || isFocused) ? 0 : -1}
              data-value={day}
              onClick={(e) => {
                e.preventDefault();
                setSeletedDate(new Date(day));
              }}
              disabled={disabled}
              ref={ref}
              aria-labelledby={ariaLabelledBy}
              aria-label={label}
              aria-current={isSelected}
            >
              {day.getDate()}
            </button>
        )}
      </td>
    );
  }
);

Day.displayName = "Day"

export default Day;
